import { render, staticRenderFns } from "./boons.vue?vue&type=template&id=a748a804&scoped=true&"
import script from "./boons.vue?vue&type=script&lang=js&"
export * from "./boons.vue?vue&type=script&lang=js&"
import style0 from "./boons.vue?vue&type=style&index=0&id=a748a804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a748a804",
  null
  
)

export default component.exports